import CityPageTemplate from "../city-template/CityPageTemplate";
import { newarkConfig } from "./data";

export default function NewarkPage() {
  return <CityPageTemplate config={newarkConfig} />;
}